<template>
  <div>
    <accordion
      id="first-id"
      :label="this.$i18n.t('ACTIVATE.INFO1.HEADER')"
    >
      <p>
        {{ this.$i18n.t('ACTIVATE.INFO1.P1') }}
      </p>
      <p>
        <strong>{{ this.$i18n.t('ACTIVATE.NOTE') }}</strong>
        {{ this.$i18n.t('ACTIVATE.INFO1.P2') }}
        <a
          :href="dreitvLink"
          target="_blank"
        >
          {{ this.$i18n.t('ACTIVATE.INFO1.KUNDENZONE') }}
        </a>
        {{ this.$i18n.t('ACTIVATE.INFO1.P3') }}
      </p>
      <div class="img-container">
        <img
          class="img-small"
          src="@/assets/image/Streamingkarte_Mockup.png"
        >
      </div>
    </accordion>
    <accordion
      id="second-id"
      :label="this.$i18n.t('ACTIVATE.INFO2.HEADER')"
    >
      <p>
        {{ this.$i18n.t('ACTIVATE.INFO2.P1') }}
        <a
          :href="dreiShops.link"
          target="_self"
        >
          {{ dreiShops.title }}
        </a>
      </p>
    </accordion>
    <accordion
      id="0-id"
      :label="this.$i18n.t('ACTIVATE.INFO2_AND_A_HALF.HEADER')"
    >
      <p>
        {{ this.$i18n.t('ACTIVATE.INFO2_AND_A_HALF.P1') }}
        <a
          :href="dreitvLink"
          target="_blank"
        >
          {{ dreitvLinkDisplay }}
        </a>
        {{ this.$i18n.t('ACTIVATE.INFO2_AND_A_HALF.P2') }}
      </p>
      <ul class="list list--diamond">
        <li>{{ this.$i18n.t('ACTIVATE.INFO2_AND_A_HALF.LI1') }}</li>
        <li>{{ this.$i18n.t('ACTIVATE.INFO2_AND_A_HALF.LI2') }}</li>
        <li>{{ this.$i18n.t('ACTIVATE.INFO2_AND_A_HALF.LI3') }}</li>
      </ul>
    </accordion>
    <accordion
      id="third-id"
      :label="this.$i18n.t('ACTIVATE.INFO3.HEADER')"
    >
      <p>
        {{ this.$i18n.t('ACTIVATE.INFO3.P1') }}
        <a
          :href="dreitvLink"
          target="_blank"
        >
          {{ dreitvLinkDisplay }}
        </a>
        {{ this.$i18n.t('ACTIVATE.INFO3.P2') }}
      </p>
    </accordion>
    <accordion
      id="fourth-id"
      :label="this.$i18n.t('ACTIVATE.INFO4.HEADER')"
    >
      <p>
        {{ this.$i18n.t('ACTIVATE.INFO4.P1') }}
        <a
          :href="dreitvLink"
          target="_blank"
        >
          {{ dreitvLinkDisplay }}
        </a>
        {{ this.$i18n.t('ACTIVATE.INFO4.P2') }}
      </p>
    </accordion>
    <accordion
      id="fifth-id"
      :label="this.$i18n.t('ACTIVATE.INFO5.HEADER')"
    >
      <p>
        {{ this.$i18n.t('ACTIVATE.INFO5.P1') }}
        <a
          :href="dreitvLink"
          target="_blank"
        >
          {{ dreitvLinkDisplay }}
        </a>
        {{ this.$i18n.t('ACTIVATE.INFO5.P2') }}
      </p>
    </accordion>
  </div>
</template>

<script>

export default {
  name: 'ActivationAccordions',
  components: { },
  data: function() {
    return {
      dreitvLinkDisplay: 'www.drei.at/dreitvkarte',
      dreitvLink: 'https://www.drei.at/dreitvkarte',
      dreiShops: {
        title: 'Drei Shops.',
        link: '/n/shops/s?EmpfohleneStandorte=Drei+Shops+%26+Drei+BestPartner+Gold',
      }
    };
  },
}
</script>

<style lang="scss" src="@/components/img.scss">
</style>
